<template>
  <div>
    <innerHeader />
    <login />
  </div>
</template>

<script>
import innerHeader from "@/components/header/innerHeader";
import login from "@/components/loginPage.vue";

export default {
  name: 'loginpage',
  components: {
    innerHeader,
    login
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/loginpage.scss";
</style>
